import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormBaseComponent } from "./../form-base/form-base.component";

@Component({
  selector: "app-form-acao",
  templateUrl: "./form-acao.component.html",
  styleUrls: ["../form-base/form-base.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormAcaoComponent extends FormBaseComponent {}
